export const UPLOAD_FILE = 'app/PlanImporter/UPLOAD_FILE'
export const UPLOAD_IMAGES = 'app/PlanImporter/UPLOAD_IMAGES'
export const UPLOAD_IMAGES_DONE = 'app/PlanImporter/UPLOAD_IMAGES_DONE'
export const UPLOAD_PLAN = 'app/PlanImporter/UPLOAD_PLAN'
export const UPLOAD_PLAN_DONE = 'app/PlanImporter/UPLOAD_PLAN_DONE'
export const UPLOAD_PLAN_ERROR = 'app/PlanImporter/UPLOAD_PLAN_ERROR'
export const UPLOAD_ERROR = 'app/PlanImporter/UPLOAD_ERROR'
export const FILE_UPLOADED = 'app/PlanImporter/FILE_UPLOADED'

export const GET_PDF_THUMBNAIL_AS_JPEG =
  'app/PlanImporter/GET_PDF_THUMBNAIL_AS_JPEG'
export const GET_PDF_THUMBNAIL_AS_JPEG_DONE =
  'app/PlanImporter/GET_PDF_THUMBNAIL_AS_JPEG_DONE'
export const GET_PDF_THUMBNAIL_AS_JPEG_STATUS =
  'app/PlanImporter/GET_PDF_THUMBNAIL_AS_JPEG_STATUS'
export const GET_PDF_THUMBNAIL_AS_JPEG_ERROR =
  'app/PlanImporter/GET_PDF_THUMBNAIL_AS_JPEG_ERROR'

export const MAX_PLAN_UPLOAD = 10
